import Backend from 'App/Dataman-Backend';

const { apiUrlStandingReports, apiUrlSuffix } = Backend.config;

export const STANDING_REPORTS_PATHS = {
  standingReports: apiUrlStandingReports,
  suffix: apiUrlSuffix,
};
